import mapActions from './mapActions';

export default mapActions('order_material_quantity', {
    fetchAll_url: (data) => {
        return `/api/orders/${data.orderId}/material_quantity`;
    }
});